import { useParams } from "react-router-dom";

export const useStoreProjectAssigneeId = () => {
  const { assigneeId } = useParams();
  return assigneeId as string;
};
